import { footerLinkStyle, linkStyle } from "@/styles/sharedStyle";
import { Font, Icon } from "@moneyforward/mfx_biz_react_components";
import { css } from "@emotion/react";

type Props = { register?: boolean };

export const TermsOfUseLink = (props: Props) => {
  return (
    <>
      <a
        css={props.register ? linkStyle : footerLinkStyle}
        href="/terms/id"
        target="_blank"
      >
        <Font variant="m" component="span">
          Mikatano ID 利用規約
        </Font>
        {props.register ? (
          <Font variant="m" component="span">
            {" "}
            <Icon css={icon} name="openInNew" size="sm" />{" "}
          </Font>
        ) : null}
      </a>
      {props.register ? (
        <Font variant="m" component="span">
          に同意する
        </Font>
      ) : null}
    </>
  );
};
const icon = css({
  cursor: "pointer",
  margin: "4px",
});
